import React, { useState } from "react";

// import JS files
import Header from "../shares/others/Header";
import moment from "jalali-moment";

// import others files
import userIcon from "../../assets/imgs/user-icon.svg";
import useFetch from "../../context/useFetch";
import { useParams } from "react-router-dom";



const CommentsList = (props) => {
  const [newsComment, setNewsComment] = useState([]);
  const { id } = useParams();
  const getNewsTwo = useFetch({
    method: "get",
    url: `News_Service/${id}/get_news_comments`,
    noHeader: true,
    trigger: true,
    argFunc: (res) => {
      setNewsComment(res.comments);
    },
  });
  return (
    <>
      {newsComment.length > 0 && (
        <div className="mt-8">
          <Header header="نظرات کاربران" noAllItems />
          <div className="mt-8">
            {newsComment.map((item, index) => {
              return (
                <div className="pb-4 border-b border-mygrays-100 md:mx-8 last:border-b-0 mt-4">
                  <div className=" flex items-center justify-between">
                    <div className=" flex items-center">
                      <img src={userIcon} />
                      <span className="mr-4 text-myblacks-400 font-bold text-sm">
                        {item.name}
                      </span>
                    </div>
                    <div className=" flex items-center text-myblacks-100 text-xs">
                      <span>{item.time}</span>
                      <span className="mr-4">
                        {" "}
                        {moment(item.created_at, "YYYY/MM/DD")
                          .locale("fa")
                          .format("YYYY/MM/DD")}
                      </span>
                    </div>
                  </div>
                  <div className="mx-4 md:mx-12 text-justify mt-4 md:mt-0">
                    <span
                      className="text-myblacks-300 text-xs md:text-base"
                      style={{ lineHeight: 2 }}
                    >
                      {item.comment}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default CommentsList;
